import { Card, Divider, Flex, Space, Spin } from "antd";
import WorkFlowList from "features/attendance/components/WorkFlowList";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const WelfareWorkflow = () => {
    const { t } = useTranslation();
    const isLoadingWelfare = useSelector((state) => state.welfare.isLoadingWelfare);

    return (
        <Card
            style={{
                backgroundColor: "white",
                width: "100%",
                boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.15)',
                borderRadius: "20px",
            }}
        >
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <span style={{ fontSize: "18px", fontWeight: "bold", color: "#313131" }}>
                        {t("welfare.label.welfare_workflow")}
                    </span>
                    <Divider />
                </Flex>

                <Spin spinning={isLoadingWelfare} >
                    <WorkFlowList type={"WELFARE"} />
                </Spin>
            </Space>
        </Card>
    )
}

export default WelfareWorkflow;